function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { ActionButton } from '@keen.io/ui-core';
import { Container, FilterItem } from './Filter.styles';
import FilterProperty from '../FilterProperty';
import FilterOperator from '../FilterOperator';
import FilterValue from '../FilterValue';
import { setDefaultValue, setOperator, isComponentChange } from '../../utils';

var Filter = function Filter(_ref) {
  var id = _ref.id,
      filter = _ref.filter,
      properties = _ref.properties,
      onRemove = _ref.onRemove,
      onSearchProperties = _ref.onSearchProperties,
      onPropertyChange = _ref.onPropertyChange,
      _onChange = _ref.onChange,
      funnelStepId = _ref.funnelStepId;
  var propertyName = filter.propertyName,
      propertyType = filter.propertyType,
      propertyValue = filter.propertyValue,
      operator = filter.operator;
  return React.createElement(Container, {
    "data-testid": "filter-item"
  }, React.createElement(FilterItem, null, React.createElement(FilterProperty, {
    property: propertyName,
    type: propertyType,
    properties: properties,
    onBlur: function onBlur() {
      if (!propertyName) onRemove();
    },
    onSelectProperty: function onSelectProperty(property) {
      return onPropertyChange(property);
    },
    onCastPropertyType: function onCastPropertyType(propertyType) {
      var operator = setOperator(propertyType, filter.operator);

      _onChange(_objectSpread(_objectSpread({}, filter), {}, {
        propertyType: propertyType,
        operator: operator,
        propertyValue: setDefaultValue(propertyType, operator)
      }));
    },
    onSearchProperties: onSearchProperties
  })), React.createElement(FilterItem, null, React.createElement(FilterOperator, {
    property: propertyName,
    propertyType: propertyType,
    operator: operator,
    onChange: function onChange(updatedOperator) {
      var componentChange = isComponentChange(propertyType, operator, updatedOperator);
      var filterValue = componentChange ? setDefaultValue(propertyType, updatedOperator) : propertyValue;

      _onChange(_objectSpread(_objectSpread({}, filter), {}, {
        operator: updatedOperator,
        propertyValue: filterValue
      }));
    }
  })), React.createElement(FilterItem, null, React.createElement(FilterValue, {
    id: id,
    value: propertyValue,
    operator: operator,
    onChange: function onChange(value) {
      return _onChange(_objectSpread(_objectSpread({}, filter), {}, {
        propertyValue: value
      }));
    },
    propertyType: propertyType,
    propertyName: propertyName,
    funnelStepId: funnelStepId
  })), React.createElement(FilterItem, null, React.createElement(ActionButton, {
    action: "remove",
    onClick: onRemove
  })));
};

export default Filter;